import noop from 'lodash/noop';
import { createActions } from 'redux-actions';
export const whatsappActions = createActions({
    WHATSAPP_GET_APPS: [
        (payload) => payload,
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    WHATSAPP_GET_INTEGRATIONS: [
        (payload) => payload,
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    WHATSAPP_UPDATE_INTEGRATION: [
        (payload) => payload,
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    WHATSAPP_DELETE_INTEGRATION: [
        (payload) => payload,
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    WHATSAPP_SIGNUP: [
        (payload) => payload,
        (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
}, 'WHATSAPP_SET_ASYNC_STATUS', 'WHATSAPP_SET_APPS', 'WHATSAPP_SET_INTEGRATIONS');
